 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		9: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"61378f069c39c426b9ee00da39a80d30a27bd4b7","1":"4a7304bd1794afd0e26a6323504903438abaf35e","2":"f67a7b2a37c303c38290d3f9cdedcd0f6e56cbc8","3":"8a67d46c9845852e3f0d7d085f253c089df271cf","5":"91ebc4e2ed2faa240f9a6ed45c687ce9322f0da9","6":"FooterDefault","7":"pages-payments","8":"styles","12":"component---src-pages-404-tsx","13":"component---src-pages-checkout-2-index-tsx","14":"component---src-pages-checkout-3-index-tsx","15":"component---src-pages-checkout-index-tsx","16":"component---src-pages-contacts-tsx","17":"component---src-pages-email-tsx","18":"component---src-pages-faq-tsx","19":"component---src-pages-home-index-tsx","20":"component---src-pages-index-tsx","21":"component---src-pages-out-of-stock-tsx","22":"component---src-pages-privacy-policy-tsx","23":"component---src-pages-quiz-index-tsx","24":"component---src-pages-success-tsx","25":"component---src-pages-summary-2-index-tsx","26":"component---src-pages-summary-3-index-tsx","27":"component---src-pages-summary-index-tsx","28":"component---src-pages-terms-of-services-tsx","29":"component---src-pages-upsell-index-tsx","32":"sections-Benefits","33":"sections-GetTreatmentOnline","34":"sections-Hero","35":"sections-LivingWithHeartIssues","36":"sections-SymptomFree"}[chunkId]||chunkId) + "-" + {"0":"e7661f4c0e0f1fcb5cf7","1":"717701445e584f4956f9","2":"85e87b8b1280a58f9680","3":"698850ae1697d0f7b168","4":"a4b425c89beb1e71dba7","5":"686f7ebc529dcda0ec1c","6":"2c714203d0294963f239","7":"1ed927b6aa5c0a58d018","8":"d7388324b5d2ddb4e149","10":"675f7b178d4e08b96a93","12":"ac78ee7ff36bdb4e326d","13":"ed122b62c0085cbcd5a6","14":"7aeceda374f249566b7f","15":"0e9ea3bc75f84589e020","16":"ff3a00ee9d246a020329","17":"25572a3924de1ba608bc","18":"e302946d5a979dc45bf2","19":"77176738e42982d139ce","20":"a1827f5721a4f11555f4","21":"ff437c4dfcd73d885c50","22":"35fa5a66a21ef3255d44","23":"7eda370cb13e8626a39e","24":"02eb3365ab00de5e9f98","25":"d71be001ace0c6444dfe","26":"9f7764151404c18adc8e","27":"ffa446f89ee72034a990","28":"d6ee1c9f219986c60ca1","29":"e93610d8d8c095f1b39d","32":"291c93586d87bd4a865b","33":"2782c2ca89b707ef3959","34":"c34a6944c32fa2274f92","35":"4f8ecb8cb89dfbb8ce31","36":"739e8ba3e449bc175659","37":"4af87ff5ef426a0fb096","38":"22438156c9f0e690cdf0","39":"2f1e3d56042900ea478c","40":"b9480bbac7f1e8be12e0","41":"dc24dac91bcde5af1118","42":"c0a6c81912399127397f","43":"c9cbcd1cc34786d91dcf","44":"9a82d44f8cbb852d5bba","45":"3386722e46da77dcd97b","46":"0b34e55efa35c4ef6025","47":"2ed95ceea0bb59960390","48":"73e9a71af7ef2dd0f358","49":"4d2354a3da511ac90771","50":"992f75a5b3a94560774b","51":"f0f1eb765507182778fb","52":"00ecb8cdead2e5a818ae","53":"61af2f3b207b35bc3829","54":"12c6498d6961b27cf0d3","55":"f0763a23c7660b447fe9","56":"2be5f6ce95f3683f408a","57":"c74cac0837d671b99e3a","58":"f0b05f3ec2d458b2bff9","59":"384787bf9b395cc8aaf9","60":"9ca07794964ebf174c5a","61":"019c026c8d580508e07c","62":"dc7c6ab5a1e22a9c2031","63":"b1e7eb9b010b59cd16d8","64":"efe32982fe593bbc481f","65":"229affb9d03ad7deea65","66":"dc7d12c1ef9edc94cd4d","67":"aeaf356ac4fe21eb9b98","68":"f3e98b420e814048a96a","69":"629cec411e25102de4f9","70":"8118f0234643fb2e26b8","71":"dec92b9fede94f39b253","72":"d9bde00bea3cb255394a","73":"fb9501dfb085f26d4c6a","74":"44932207b9b3c9a28a49","75":"d4f9da30819ecb2a4425","76":"415dc96cf8f9101d9f98","77":"276d686976b6cf27b163","78":"c0acb37e039469b6507b","79":"d38ef0f0a61aa6366508","80":"36c69aa025c081a6022f","81":"7105c592499c219791f6","82":"ef8dd7bda88b44cb7beb","83":"e50c545001e505819ec4","84":"623b1ebd6f8fbfc34cf8","85":"9408985c4fdeedfbcb2c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"8":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"61378f069c39c426b9ee00da39a80d30a27bd4b7","1":"4a7304bd1794afd0e26a6323504903438abaf35e","2":"f67a7b2a37c303c38290d3f9cdedcd0f6e56cbc8","3":"8a67d46c9845852e3f0d7d085f253c089df271cf","5":"91ebc4e2ed2faa240f9a6ed45c687ce9322f0da9","6":"FooterDefault","7":"pages-payments","8":"styles","12":"component---src-pages-404-tsx","13":"component---src-pages-checkout-2-index-tsx","14":"component---src-pages-checkout-3-index-tsx","15":"component---src-pages-checkout-index-tsx","16":"component---src-pages-contacts-tsx","17":"component---src-pages-email-tsx","18":"component---src-pages-faq-tsx","19":"component---src-pages-home-index-tsx","20":"component---src-pages-index-tsx","21":"component---src-pages-out-of-stock-tsx","22":"component---src-pages-privacy-policy-tsx","23":"component---src-pages-quiz-index-tsx","24":"component---src-pages-success-tsx","25":"component---src-pages-summary-2-index-tsx","26":"component---src-pages-summary-3-index-tsx","27":"component---src-pages-summary-index-tsx","28":"component---src-pages-terms-of-services-tsx","29":"component---src-pages-upsell-index-tsx","32":"sections-Benefits","33":"sections-GetTreatmentOnline","34":"sections-Hero","35":"sections-LivingWithHeartIssues","36":"sections-SymptomFree"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"983180ed7b63f71ebab2","10":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c","84":"31d6cfe0d16ae931b73c","85":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
